import * as React from "react";
import type { useHistory } from "react-router-dom";

import { MarketDataConnectGateNotice } from "./MarketDataConnectGateNotice";
import {
  MARKET_DATA_PREFERENCE_SETTINGS_PATH,
  type MarketDataConnectGateState,
} from "../../utils/marketDataConnectGate";

export type WizardMarketDataOhlcGateNoticeProps = {
  gate: MarketDataConnectGateState;
  history: ReturnType<typeof useHistory>;
  onOpenMarketDataSetup: () => void;
  className?: string;
};

/** Standard inline Layer B notice + CTA navigation for stepped wizards. */
export function WizardMarketDataOhlcGateNotice({
  gate,
  history,
  onOpenMarketDataSetup,
  className,
}: WizardMarketDataOhlcGateNoticeProps): React.ReactElement {
  return (
    <MarketDataConnectGateNotice
      className={className}
      message={gate.message}
      action={gate.action}
      tradeAnalyticsAvailable={gate.trade_analytics_available}
      onNavigate={(href) => {
        if (href === MARKET_DATA_PREFERENCE_SETTINGS_PATH) {
          onOpenMarketDataSetup();
          return;
        }
        history.push(href);
      }}
    />
  );
}
